import { Box, styled } from "@mui/material";

const StyledBoxCustom = styled(Box)((props: { m?: string; p?: string }) => ({
  m: props.m,
  p: props.p,
}));
export default StyledBoxCustom;
